<script>
this.globalThis || (this.globalThis = this)
</script>
<template>
  <div class="overnight-container">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      label-position="top"
      size="small"
    >
      <div class="person-info clearfix" style="margin-bottom: 20px">
        <h3>{{ $t("app.personalInfo") }}</h3>
        <el-divider></el-divider>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.name')" prop="name">
            <el-input v-model="ruleForm.name" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.studentNumber')" prop="studentCode">
            <el-input
              v-model="ruleForm.studentCode"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.contactNumber')" prop="tel">
            <el-input v-model="ruleForm.tel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.roomNumber')" prop="roomCode">
            <el-input v-model="ruleForm.roomCode" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="application-form">
        <h3>{{ $t("app.declarationItems") }}</h3>
        <el-divider></el-divider>
        <el-form-item prop="date" :label="$t('app.overnightView.date')">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            :placeholder="$t('app.validation.date')"
            v-model="ruleForm.date"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="$t('app.overnightView.factor')"
          prop="factor"
          v-show="factorVisible"
        >
          <el-radio-group v-model="ruleForm.factor">
            <el-radio :style="!$store.state.Config.device?{whiteSpace: 'pre-wrap', display: 'block'}
            :{display: 'block'}" :label="'1'">{{
              $t("app.overnightView.factorI")
            }}</el-radio>
            <br />
            <el-radio :style="!$store.state.Config.device?{whiteSpace: 'pre-wrap', display: 'block'}
            :{display: 'block'}" :label="'2'">{{
              $t("app.overnightView.factorII")
            }}</el-radio>
            <br />
            <el-radio :style="!$store.state.Config.device?{whiteSpace: 'pre-wrap', display: 'block'}
            :{display: 'block'}" :label="'3'">{{ factor }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('app.overnightView.isLeave')"
          v-show="isLeaveVisible"
          prop="destination"
          class="customRequired"
        >
          <el-input v-model="ruleForm.destination"></el-input>
        </el-form-item>
        <el-form-item :label="$t('app.overnightView.reason')" prop="reason">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            v-model="ruleForm.reason"
            :style="!$store.state.Config.device? '' : {width: '600px'}"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('app.statement')" prop="declareFinal">
          <el-checkbox class="phoneCheckbox" :style="!$store.state.Config.device?{whiteSpace: 'pre-wrap', display: 'block'}
            :{display: 'block'}" v-model="ruleForm.declareFinal">{{
            $t("app.overnightView.declare")
          }}</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            @click="submitForm('ruleForm')"
            >{{ $t("app.submit") }}</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')">{{
            $t("app.reset")
          }}</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import { submit, getBaseInfo, getFactor } from "@/api/overnight";
export default {
  data() {
    var declareCheck = (rule, value, callback) => {
      const that = this;
      if (!value) {
        callback(new Error(that.$t("app.validation.declare")));
      } else {
        callback();
      }
    };
    var destinationCheck = (rule, value, callback) => {
      if (this.ruleForm.factor === "2" && !value) {
        callback(new Error(this.$t("app.validation.destination")));
      } else {
        callback();
      }
    };
    return {
      factorVisible: false,
      factor: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      loading: false,
      ruleForm: {
        name: "",
        studentCode: "",
        roomCode: "",
        tel: "",
        factor: "",
        declareFinal: "",
        date: "",
        reason: "",
        destination: "",
      },
      rules: {
        declareFinal: [
          { required: true, validator: declareCheck, trigger: "blur" },
        ],
        name: [
          {
            required: true,
            message: this.$t("app.validation.name"),
            trigger: "blur",
          },
        ],
        studentCode: [
          {
            required: true,
            message: this.$t("app.validation.studentNumber"),
            trigger: "blur",
          },
        ],
        reason: [
          {
            required: true,
            message: this.$t("app.validation.reason"),
            trigger: "blur",
          },
        ],
        roomCode: [
          {
            required: true,
            message: this.$t("app.validation.roomNumber"),
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: this.$t("app.validation.phone"),
            trigger: "blur",
          },
        ],
        factor: [
          {
            required: true,
            message: this.$t("app.validation.select"),
            trigger: "blur",
          },
        ],
        destination: [
          {
            required: false,
            validator: destinationCheck,
            trigger: "blur",
          },
        ],
        date: [
          {
            required: true,
            message: this.$t("app.validation.date"),
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    getBaseInfo().then((res) => {
      this.ruleForm.name = res.data.Name;
      this.ruleForm.studentCode = res.data.StudentCode;
      this.ruleForm.roomCode = res.data.CurrentRoom;
      this.ruleForm.tel = res.data.ContactMobile;
      this.ruleForm.factor = res.data.ApplyItem;
      this.ruleForm.date = res.data.ApplyDate || "";
      this.ruleForm.reason = res.data.ApplyReason;
    });
  },
  watch: {
    "ruleForm.date"(val) {
      if (!val) {
        this.factorVisible = false;
        return;
      }
      getFactor({ expectedDate: val }).then((res) => {
        this.factor = res.data;
        this.factorVisible = true;
      });
    },
  },
  computed: {
    isLeaveVisible() {
      return this.ruleForm.factor === "2";
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          submit({
            Name: this.ruleForm.name,
            StudentCode: this.ruleForm.studentCode,
            ContactMobile: this.ruleForm.tel,
            CurrentRoom: this.ruleForm.roomCode,
            ApplyItem: this.ruleForm.factor,
            ApplyDate: this.ruleForm.date,
            ApplyReason: this.ruleForm.reason,
            Destination: this.ruleForm.destination,
          })
            .then(() => {
              this.$message({
                message: this.$t("app.opeSuccess"),
                type: "success",
              });
              this.loading = false;
              this.$router.push("/returnInNight")
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.overnight-container {
  overflow: auto;
  .person-info,
  .application-form {
    background-color: #fff;
    padding: 15px;
    border: solid 1px #ccc;
    border-radius:5px ;
  }
}
</style>
<style lang="scss" scoped>
.overnight-container {
  .person-info,
  .application-form {
    .el-form-item__content {
      padding: 0 15px;
    }
    .el-input {
      width: 300px;
    }
    .el-radio {
      margin-bottom: 6px;
    }
  }
  .customRequired {
    label:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
.phoneCheckbox {
  ::v-deep .el-checkbox__label {
    display: inline;
  }
}
</style>
